exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-dialog-content {\r\n  overflow-y: hidden !important;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/lista-stampanti-dialog/lista-stampanti-dialog.component.css
// module id = ./src/app/lista-stampanti-dialog/lista-stampanti-dialog.component.css
// module chunks = main